module.exports = __webpack_public_path__ + "img/NorthDash_TitleBaldrod.ceddc276.png";